// extracted by mini-css-extract-plugin
export default {"body":"UnshareProjectModal_body__01FIW","button":"UnshareProjectModal_button__jOFB1"};